import { Accordion, AccordionDetails, AccordionSummary, Box, Paper, Tooltip, Typography, IconButton } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import { ElementInfoItem } from "./elementInfoItem";
import { useTheme } from '@mui/material/styles';
import { ElementButtonDelete } from "./elementButtonDelete";
import { ElementButtonEdit } from "./elementButtonEdit";


export const ElementInfo = (props) => {
  const [accordionOpen, setAccordionOpen] = React.useState(false);
  const theme = useTheme();
  const data = props.item?.data || {};

  const handleLinkClick = (event) => {
    event.preventDefault();
    if (data.url) {
      window.open(data.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (

    <Paper elevation={0} sx={{
      position: "absolute",
      backgroundColor: theme.palette.appBarBg.main,
      top: { xs: '62px', sm: '72px' }, // Offset for app bar height (56px mobile, 64px desktop)
      left: '8px',
      width: '260px',
      zIndex: 1200 // Above canvas but below app bar (which is 1300)
    }}>
      <Accordion expanded={accordionOpen}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.common.white }} onClick={() => setAccordionOpen(!accordionOpen)} />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          sx={{ backgroundColor: theme.palette.appBarBg.main }}

        >
          <Box width="200px" display="flex">
            <Tooltip title={data?.name}>
              <Typography
                variant="body2"
                noWrap
                sx={{ width: 1, color: theme.palette.common.white }}
              >
                {data?.name}
              </Typography>
            </Tooltip>
            <Box wrap='nowrap' justifyContent="flex-end" alignContent="flex-end" display="flex">

              {!((props.ispublic === true) || (props.ispublic === 'true')) &&
                <ElementButtonEdit canvasRef={props.canvasRef} item={props?.item} type={props?.item?.group} />
              }
              {data?.url && <Tooltip title="Open link">
                <IconButton size="small" onClick={handleLinkClick} sx={{ color: theme.palette.common.white }}>
                  <LinkIcon sx={{ fontSize: 15, color: theme.palette.common.white }} />
                </IconButton>
              </Tooltip>}
              {!((props.ispublic === true) || (props.ispublic === 'true')) &&
                <ElementButtonDelete canvasRef={props.canvasRef} />
              }
            </Box>
          </Box>
        </AccordionSummary>

        <AccordionDetails>
          <ElementInfoItem label="Name" value={data?.name}></ElementInfoItem>
          <ElementInfoItem label="Description" value={data?.description}></ElementInfoItem>
          <ElementInfoItem label="First Name" value={data?.firstname}></ElementInfoItem>
          <ElementInfoItem label="Last Name" value={data?.lastname}></ElementInfoItem>
          <ElementInfoItem label="Web" value={data?.url}></ElementInfoItem>
          <ElementInfoItem label="Company" value={data?.company}></ElementInfoItem>
          <ElementInfoItem label="Position" value={data?.position}></ElementInfoItem>
          <ElementInfoItem label="Custom 1" value={data?.customfield1}></ElementInfoItem>
          <ElementInfoItem label="Custom 2" value={data?.customfield2}></ElementInfoItem>
          <ElementInfoItem label="Custom 3" value={data?.customfield3}></ElementInfoItem>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};